import { render, staticRenderFns } from "./insComp.vue?vue&type=template&id=5e1e46e8"
import script from "./insComp.vue?vue&type=script&lang=js"
export * from "./insComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports